var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUrlPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16443",
    "data-name": "Grupo 16443",
    transform: "translate(-43 -1363)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(43 1363)",
    fill: "#d13c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_245",
    "data-name": "Caminho 245",
    d: "M15.243,6.757A6,6,0,1,0,17,11,5.961,5.961,0,0,0,15.243,6.757ZM11.193,8.652a12.137,12.137,0,0,0,2.137-.22,10.2,10.2,0,0,1,.311,2.376H11.193Zm0-.388V5.537a2.491,2.491,0,0,1,1.639,1.539,6.618,6.618,0,0,1,.391.983A11.8,11.8,0,0,1,11.193,8.264Zm-.387,0a11.8,11.8,0,0,1-2.029-.207,6.618,6.618,0,0,1,.391-.983,2.5,2.5,0,0,1,1.639-1.539Zm0,.388v2.155H8.359a10.214,10.214,0,0,1,.311-2.376A12.265,12.265,0,0,0,10.807,8.652ZM7.972,10.807H5.392A5.576,5.576,0,0,1,6.433,7.743a10.629,10.629,0,0,0,1.857.608A10.627,10.627,0,0,0,7.972,10.807Zm0,.387a10.627,10.627,0,0,0,.319,2.456,10.629,10.629,0,0,0-1.857.608,5.576,5.576,0,0,1-1.041-3.064Zm.387,0h2.447v2.155a12.137,12.137,0,0,0-2.137.22A10.256,10.256,0,0,1,8.359,11.193Zm2.448,2.543v2.728a2.491,2.491,0,0,1-1.639-1.539,6.618,6.618,0,0,1-.391-.983A11.672,11.672,0,0,1,10.807,13.736Zm.387,0a11.8,11.8,0,0,1,2.029.207,6.618,6.618,0,0,1-.391.983,2.494,2.494,0,0,1-1.639,1.539Zm0-.388V11.193H13.64a10.214,10.214,0,0,1-.311,2.376A12.236,12.236,0,0,0,11.193,13.348Zm2.835-2.155h2.58a5.576,5.576,0,0,1-1.041,3.064,10.629,10.629,0,0,0-1.857-.608A10.627,10.627,0,0,0,14.028,11.193Zm0-.387a10.627,10.627,0,0,0-.319-2.456,10.629,10.629,0,0,0,1.857-.608,5.576,5.576,0,0,1,1.041,3.064Zm1.3-3.38a10.3,10.3,0,0,1-1.721.552A6.982,6.982,0,0,0,13.177,6.9a3.733,3.733,0,0,0-1.125-1.413A5.6,5.6,0,0,1,15.324,7.427ZM9.947,5.488A3.743,3.743,0,0,0,8.821,6.9,7.12,7.12,0,0,0,8.4,7.977a10.3,10.3,0,0,1-1.721-.552A5.626,5.626,0,0,1,9.947,5.488ZM6.676,14.573A10.3,10.3,0,0,1,8.4,14.021,6.982,6.982,0,0,0,8.823,15.1a3.733,3.733,0,0,0,1.125,1.413A5.6,5.6,0,0,1,6.676,14.573Zm5.377,1.939A3.743,3.743,0,0,0,13.179,15.1a7.12,7.12,0,0,0,.425-1.076,10.3,10.3,0,0,1,1.721.552A5.626,5.626,0,0,1,12.053,16.512Z",
    transform: "translate(41 1361)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUrlPerfil);
export default __webpack_public_path__ + "static/media/ico-url-perfil.4c3ab62e1dce23d00a3dd09b2261ef1d.svg";
export { ForwardRef as ReactComponent };